import io from "socket.io-client";
var Cookies = require("js-cookie")

console.log("Socket Process env: ", process.env.REACT_APP_API_ENDPOINT_SOCKET);
const socket = io(process.env.REACT_APP_API_ENDPOINT_SOCKET,{
    query:{
        Token: 'Bearer ' + Cookies.get("token")
    }
});
export default socket;
